import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TecNoDataRowDirective } from './tec-no-data-row.directive';

@NgModule({
  declarations: [TecNoDataRowDirective],
  imports: [CommonModule],
  exports: [TecNoDataRowDirective],
})
export class TecNoDataRowModule {}
